/**
 * Formula creation utility - extracted to break circular dependency
 * between formulaConditions.ts and formulaTools.ts
 */
import type { Formula } from "building-types/options/formula";

export function formulaNew(formula: string): Formula {
  return { type: "FORMULA", formula };
}
